import { ChangeEvent } from "react";

export const parseEventFloat = (e: ChangeEvent<HTMLInputElement>) => {
  const floatValue = e.target.valueAsNumber;
  return isNaN(floatValue) ? undefined : floatValue;
};

export const getPercentageFormatter =
  (precision = 0) =>
  (f: number) =>
    `${(f * 100).toFixed(precision)}%`;

export const getCountableFormatter =
  (single: string, plural: string) => (f: number) => {
    const i = Math.round(f);
    return i === 1 ? `${i} ${single}` : `${i} ${plural}`;
  };

export const currencyFormat = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

// https://stackoverflow.com/a/65666402
export function throwExpression(errorMessage: string): never {
  throw new Error(errorMessage);
}

export const sentenceCase = (valueOrUndefined: string) => {
  const value = valueOrUndefined ?? "";
  return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
};
